import {
  SEND_FEEDBACK,
  SEND_FEEDBACK_SUCCESS,
  SEND_FEEDBACK_ERROR,
} from "./actionType";

const initialState = {
  feedbackSuccess: null,
  loadingFeedback: false,
  error: null,
};

const feedbackGenReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEND_FEEDBACK:
      return {
        ...state,
        loadingFeedback: true,
      };
    case SEND_FEEDBACK_SUCCESS:
      return {
        ...state,
        feedbackSuccess: action.payload,
        loadingFeedback: false,
      };
    case SEND_FEEDBACK_ERROR:
      return {
        ...state,
        error: action.payload,
        loadingFeedback: false,
      };
    default:
      return state;
  }
};

export default feedbackGenReducer;
